import ApiQueue from "@/libraries/ApiQueue";
import FallbackDB from "@/libraries/localStorage";
import { getNow } from "@/helpers/format_date";
import { getMidnight } from "@/helpers/getMidnight";
import { isServerVersionNewer } from "@/helpers/isServerVersionNewer";
import { WorkIntervalModel } from "@/models/WorkIntervalModel";
import { UserModel } from "@/models/UserModel";

export const timer = {
    namespaced: true,
    state() {
        return {
            TICK_TIME__UPDATE_DB: 1e4,
            TICK_TIME__UPDATE_TIMER: 500,

            loading: false,
            loadingError: false,

            DB: [],
            workTime: 0,
        }
    },
    getters: {
        getDB(state) {
            return state.DB;
        },
        isWorking(state) {
            return state.DB.reduce((isOn, v) => isOn += !v.stop, false);
        }
    },
    mutations: {
        setDB(state, value) {
            state.DB = value;
        },
        start(state) {
            const m = new WorkIntervalModel();
            m.setData({
                id: -getNow(),
                start: +getNow(),
                stop: 0
            })
            m.flush();
        },
        stop(state) {
            // Проходимся по всем интервалам и закрываем открытый (должен быть только один, последний)
            state.DB.forEach(v => {
                if (v.stop) {
                    return;
                }
                const m = new WorkIntervalModel(v.id);
                m.stop = +getNow();
                m.flush();
            });
        }
    },
    actions: {
        async _loopUpdateDB({state}) {
            if (!UserModel.isAuth()) {
                return;
            }

            const mergeWithLocalIntervals = intervals => {
                for (let apiData of intervals) {
                    const m = new WorkIntervalModel(apiData.id);
                    if (!isServerVersionNewer(m, apiData)) {
                        continue;
                    }
                    m.setData(apiData);
                    m.setDataToDB(apiData.id)
                }
            }

            state.loading = state.loadingError = false;
            try {
                state.loading = true;

                const intervals = await ApiQueue.get('work_intervals', [], ApiQueue.REPLACE_EQUAL);
                mergeWithLocalIntervals(intervals);
            } catch (e) {
                console.error('Update timers:', e);
                state.loadingError = true;
            } finally {
                state.loading = false;
            }
        },
        async loopUpdateDB({dispatch}) {
            if (this.lockedUpdateDB) {
                return;
            }
            this.lockedUpdateDB = true;
            await dispatch('_loopUpdateDB');
            this.lockedUpdateDB = false;
        },
        async _loopUpdateTimer({state}) {
            if (!UserModel.isAuth()) {
                return;
            }

            const calcWorkTime = () => {
                const midnight = getMidnight();
                let validIntervals = state.DB;

                // Оставляем в списке для подсчёта только те интервалы:
                validIntervals = state.DB.filter(
                    v => v.start >= midnight // а) если они идут после полночи
                        ||
                        (v.start < midnight && v.stop > midnight) // б) тот который начался до полуночи, а закончился после (такой интервал будем считать с полуночи до момента его завершения)
                        ||
                        (v.start < midnight && +v.stop === 0) // в) тот который начался до полуночи и сейчас всё ещё идёт
                );
                // Например: сейчас на часах 1:00, человек нажал "работаю" вчера в 23:30, потом "стоп" в 0:30, а потом опять "старт" в 0:45
                // Тогда валидные интервалы: 23:30->0:30, 0:45->... и отработанное время будет: 0:00->0:30 + 0:45->сейчас

                state.workTime = validIntervals.reduce((summary, m) => {
                    const stop = +m.stop || +getNow();
                    summary += stop - (m.start < midnight ? midnight : m.start);
                    return summary;
                }, 0);
            }
            calcWorkTime();
        },
        async loopUpdateTimer({dispatch}) {
            if (this.lockedUpdateTimer) {
                return;
            }

            this.lockedUpdateTimer = true;
            await dispatch('_loopUpdateTimer');
            this.lockedUpdateTimer = false;
        },
        restore({commit}) {
            commit('setDB', FallbackDB.restore('work_intervals'));
        },
        init({dispatch, state}) {
            setInterval(() => dispatch('loopUpdateDB'), state.TICK_TIME__UPDATE_DB);
            dispatch('loopUpdateDB');

            setInterval(() => dispatch('loopUpdateTimer'), state.TICK_TIME__UPDATE_TIMER);
            dispatch('loopUpdateTimer');
        },
    }
}